import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceDot } from 'recharts';

const MarshallGraph = ({ data, peakX, peakY, graphRef }) => {
    // Se não houver dados, exibe um placeholder
    if (!data || data.length === 0) return <div style={{height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', borderRadius: '12px', color: '#94a3b8'}}>Aguardando processamento do gráfico...</div>;

    return (
        <div ref={graphRef} style={{ background: '#fff', padding: '20px', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
            <h4 style={{ margin: '0 0 20px 0', fontSize: '0.9rem', color: '#0f172a', textAlign: 'center' }}>Curva de Ruptura: Estabilidade vs. Fluência</h4>
            <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                    <LineChart data={data} margin={{ top: 10, right: 30, left: 10, bottom: 10 }}>
                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
                        <XAxis 
                            dataKey="x" 
                            type="number" 
                            domain={[0, 'dataMax + 0.5']} 
                            label={{ value: 'Fluência (mm)', position: 'insideBottom', offset: -5, fontSize: 12 }} 
                        />
                        <YAxis 
                            label={{ value: 'Carga (N)', angle: -90, position: 'insideLeft', fontSize: 12 }} 
                        />
                        <Tooltip 
                            formatter={(value) => [`${value} N`, 'Carga']}
                            labelFormatter={(label) => `Fluência: ${label} mm`}
                        />
                        <Line 
                            type="monotone" 
                            dataKey="y" 
                            stroke="#0369a1" 
                            strokeWidth={3} 
                            dot={false} 
                            activeDot={{ r: 6 }} 
                        />
                        {/* Ponto de Ruptura em Vermelho */}
                        <ReferenceDot x={peakX} y={peakY} r={6} fill="#ef4444" stroke="none" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
            <p style={{ textAlign: 'center', fontSize: '0.75rem', color: '#64748b', marginTop: '10px' }}>
                🔴 Ponto de Ruptura Identificado: {peakY} N a {peakX} mm
            </p>
        </div>
    );
};

export default MarshallGraph;